<template>
  <MetricCard
    data-id="metrics-subscription"
    :data-state="state"
    :label="label"
    :data-missing-addons="missingAddonsStr"
    hover="View usage"
    title="Plan"
    :status="status"
    :loading="loading"
    @click="onClick"
  />
</template>
<script setup lang="ts">
import MetricCard from '../MetricCard.vue';
import { onMounted, ref } from 'vue';

import { loadFetch } from '../../../lib/services/helpers';
import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import type { SubscriptionMetricsMissingAddonsEnum } from '@mailslurp/admin-sdk';
import {
  SubscriptionMetricsStateEnum,
  SubscriptionMetricsStatusEnum,
} from '@mailslurp/admin-sdk';
import { computed, navigateTo } from '#imports';

const store3 = useStore3();
const loading = ref(false);

const { metricsSubscription, billingPortal } = storeToRefs(store3);
const status = computed<SubscriptionMetricsStatusEnum>(
  () =>
    metricsSubscription.value?.status ?? SubscriptionMetricsStatusEnum.SUCCESS,
);
const state = computed<SubscriptionMetricsStateEnum | undefined>(() => {
  return metricsSubscription.value?.state;
});
const missingAddons = computed<
  SubscriptionMetricsMissingAddonsEnum[] | undefined
>(() => {
  return metricsSubscription.value?.missingAddons;
});
const missingAddonsStr = computed(() =>
  missingAddons.value && missingAddons.value.length
    ? missingAddons.value.join(',')
    : '0',
);
const label = computed(() => {
  switch (state.value) {
    case SubscriptionMetricsStateEnum.OKAY:
      return '';
    case SubscriptionMetricsStateEnum.FREE_ACCOUNT:
      return 'Free';
    case SubscriptionMetricsStateEnum.MISSING_ADDONS:
      return 'Missing addons';
    case SubscriptionMetricsStateEnum.PAYMENT_ERRORS:
    case SubscriptionMetricsStateEnum.PENDING_CHARGE:
      return 'Payment errors';
    case SubscriptionMetricsStateEnum.TRIAL_ACCOUNT:
      return 'Trial';
    default:
      return '';
  }
});
const onClick = async () => {
  switch (state.value) {
    case SubscriptionMetricsStateEnum.OKAY:
      navigateTo('/usage/');
      break;
    case SubscriptionMetricsStateEnum.FREE_ACCOUNT:
      navigateTo('/upgrade/');
      break;
    case SubscriptionMetricsStateEnum.MISSING_ADDONS:
      navigateTo('/upgrade/missing/');
      break;
    case SubscriptionMetricsStateEnum.PAYMENT_ERRORS:
    case SubscriptionMetricsStateEnum.PENDING_CHARGE:
      await loadFetch(() => store3.getBillingPortal(), store3, loading);
      window.location.href = billingPortal?.value?.url ?? '';
      break;
    case SubscriptionMetricsStateEnum.TRIAL_ACCOUNT:
      await navigateTo('/upgrade/');
      break;
  }
};
onMounted(async () => {
  await loadFetch(() => store3.getMetricsSubscription(), store3, loading);
});
</script>
